import { render, staticRenderFns } from "./messsages-template-variables.vue?vue&type=template&id=3e91952c&"
import script from "./messsages-template-variables.vue?vue&type=script&lang=js&"
export * from "./messsages-template-variables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports